import { ContextNotification } from '@pandiafi/components'
import React from 'react'

interface InfoNotificationProps {
  text: string
}

export const InfoNotification: React.FC<InfoNotificationProps> = ({ text }) => (
  <ContextNotification
    type="info"
    icon="info-circle"
    rounded="m"
    className="mt-8 w-full"
  >
    {text}
  </ContextNotification>
)
